
import { useState } from "react";
import IMAGES from "../../../../assets/images/images";
import { ACTION_STATUS, DEMAND_ACTIONS } from "../../../../utils/constants/DemandConstant";
import styles from "./demandReview.module.css";
import CAN from '../../../../casl/can';
import { Action, Resource } from '../../../../casl/constants';
import { ConfirmDialog } from "../../../../hooks/confirmDialog/confirmDialog";
import { Submit } from "../../../../components/button/buttons";
import { connect } from "react-redux";
import { addDemandAction } from "../../../../redux/actions/demand/demand.action";
import { openAlertPopup } from "../../../../redux/actions/Alert/alert.action";

const DemandReview = ({actionStatus,requestId,...props}) => {
  const showFloorPricingBtn = (actionStatus===ACTION_STATUS.REVIEW_INITIATED || actionStatus === ACTION_STATUS.FEASIBILITY_COMPLETED ) && CAN(Action.REVIEW_DEMAND,Resource.D2C_DEMANDS);
  const showFeasibilityBtn = actionStatus===ACTION_STATUS.REVIEW_INITIATED && CAN(Action.REVIEW_DEMAND,Resource.D2C_DEMANDS);
  const [msg, setMsg] = useState("");
  const [action, setAction] = useState(null);

  const handleConfirm = async(action) => {
    const ok = await ConfirmDialog(action);
      if (!ok.confirmed){
        setAction(null);
        return;
      }
      setAction(action);
      const payload = { action, stateData: {} };
       props.addDemandAction(payload, requestId)
        .then(() => {
          props?.openAlertPopup({
            message: action === DEMAND_ACTIONS.INITIATE_FISIBILITY ? "Feasibility assessment initiated successfully.": DEMAND_ACTIONS.INITIATE_FLOOR_PRICING ? "Floor price creation initiated successfully" : "",
            image: IMAGES.success
          });
          props.handelServiceDetailapi();
        })
        .catch((error) => {
          props?.openAlertPopup({
            message: "An error occurred while processing your request. Please try again later.",
            image: IMAGES.error
          });
        })
        .finally(() => {
          setAction(null);
        });
  
  };

  return (
    <div className={styles.demandreview}>
      <section className={styles.reviewtxt}>Once you have completed the review of the demand details, please proceed with the appropriate next action.</section>
      <div className={styles.footerwrapper}>
        <div className={styles.buttoncontainer}>
          {showFeasibilityBtn&&
          <Submit 
            onClick={() => handleConfirm(DEMAND_ACTIONS.INITIATE_FISIBILITY)} 
            style={styles.headlesend} 
            isSubmitting={action === DEMAND_ACTIONS.INITIATE_FISIBILITY}
            title={"Initiate Feasibility Assessment"}
            onMouseEnter={() => setMsg("Initiates the 'Feasibility Assessment' stage, enabling Vodafone technical/engineering teams to assess service feasibility and network availability.\nEnsure all required details are complete before proceeding")}
            onMouseLeave={() => setMsg("")}
          />}
          {showFloorPricingBtn&&
          <Submit
            onClick={() => handleConfirm(DEMAND_ACTIONS.INITIATE_FLOOR_PRICING)} 
            style={styles.headlesend} 
            isSubmitting={action === DEMAND_ACTIONS.INITIATE_FLOOR_PRICING} 
            title={"Initiate Floor Pricing"}
            onMouseEnter={() => setMsg("Initiate preparing the 'Floor Pricing' process, enabling Vodafone commercial teams to define baseline pricing for this demand.\nEnsure all required details are complete before proceeding.")}
            onMouseLeave={() => setMsg("")}
          />}
        </div>
      </div>
      {msg &&
      <div className={styles.note} role="note">
        <div className={styles.noteellipsis}>
          <img
            className={styles.noteinfo}
            src={IMAGES.infoCircle}
            alt="Information icon"
          />
          <div className={styles.noteText}>
          {msg.split('\n').map(item=><div>{item}</div>)} 
          </div>
        </div>
      </div>}
    </div>
  );
};

const mapStateToProps = (state) => {
  return null
};

const mapDispatchToProps = (dispatch) => {
  return {
    addDemandAction: (payload,id)=>{
      return dispatch(addDemandAction(payload,id))
    },
    openAlertPopup: (alertHeader,alertmessage) => {
      return dispatch(openAlertPopup(alertHeader,alertmessage))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DemandReview);
 